<template>
  <AppLayout>
    <div class="content">
      <img alt="Hellocare" src="../assets/images/signup-success.png">
      <p class="text">
        {{ $t('signupSummaryPage.text') }}
      </p>
      <div class="center">
        <ButtonGreen @click="login" :busy="isLoggingIn"> {{ $t('signupSummaryPage.continue') }} </ButtonGreen>
      </div>
    </div>
  </AppLayout>
</template>

<script>
  import AppLayout from '@/components/AppLayout.vue';
  import ButtonGreen from '@/components/ButtonGreen.vue';
  import Auth from '@/api/auth.js';
  import { getAuthorizeURL } from '@/helpers/tools.js';

  export default {
    name: 'SignupStep5Page',
    components: { ButtonGreen, AppLayout },
    data() {
      return {
        isLoggingIn: false,
      }
    },
    methods: {
      async login() {
        if (!this.$store.getters['auth/hasCredentials']) {
          return this.$router.push({ name: 'login' });
        }

        try {
          this.isLoggingIn = true;
          const { email, password } = this.$store.getters['auth/getCredentials'];
          await Auth.login(email, password);
          window.location = getAuthorizeURL();
        } catch (e) {
          this.isLoggingIn = false;
          return this.$router.push({ name: 'login' });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  img {
    display: block;
    width: 100px;
    margin: 0 auto 3rem;
  }

  .text {
    font-weight: 500;
    text-align: center;
    font-size: 3rem;
  }

  .center {
    text-align: center;
  }
</style>
